import request from '@/service/index'
import qs from 'qs'

export const getCountryList = () => {
  return request({
    url: '/common/getCountrys',
    method: 'GET'
  })
}

interface IDataStoreParams {
  platform: string
  keyword: string
}
export const getDataStoreList = (params: IDataStoreParams) => {
  return request({
    url: '/NumberTasks/DataStore/GetList',
    method: 'GET',
    params
  })
}

// 获取用户列表
export const getUserList = (params: any) => {
  return request({
    url: '/user/getlist',
    method: 'GET',
    params
  })
}

// 模糊查询用户列表
export const searchUser = (params: any) => {
  return request({
    url: '/account/GetUserInfo',
    method: 'GET',
    params
  })
}

// 查询子菜单列表接口
export const getSubMenuList = (params: any) => {
  return request({
    url: '/taskType/getlist',
    method: 'GET',
    params
  })
}

// 修改/新增任务类型
export const changeTaskData = (data: any) => {
  return request({
    url: '/taskType/save',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取修改的任务信息
export const getEditTaskData = (params: any) => {
  return request({
    url: '/taskType/getNumberType',
    method: 'POST',
    params
  })
}

// 获取用户信息ID列表
export const getUserIDList = (params: any) => {
  return request({
    url: '/user/getUserNames',
    method: 'GET',
    params
  })
}
// 获取侧边栏
export const asideTest = () => {
  return request({
    url: '/taskType/GetPlatforms',
    method: 'GET',
  })
}
